export const DEFAULT_SORT_BY = "created_at";
export const DEFAULT_ORDER_BY = "desc";
